// Small web support bundle for integrations that still require JavaScript.
//
// Persistence itself is implemented by the Dart RealmVibe package. This
// bundle deliberately contains no database models, DAO providers, Realm-JS
// runtime, WASM payload, or legacy DAO bridge. The remaining exports are
// platform support utilities used by Dart's web file-storage implementation.

import {
  clearDatabaseKey,
  installDatabaseKey,
  waitForDatabaseKey,
} from './native_database_key_handoff.js';
import { setLoggedIn as swSetLoggedIn, setLoggedInVerified } from './sw_state.js';

window.ski2NativeDatabaseKeyHandoff = {
  waitForDatabaseKey,
  installDatabaseKey,
  clearDatabaseKey,
};

// SW-visible logged-in flag store. The Dart-side writer at
// `lib/core/web/sw_logged_in_flag_web.dart` calls this function and the
// Firebase service worker reads the same origin-local flag.
window.ski2SwState = { setLoggedIn: swSetLoggedIn, setLoggedInVerified };

console.log('SKI2 web support initialized');
